// Calculation utilities matching the original helper functions
export const roundTo = (num: number, decimals: number): number => {
  return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals)
}

export const calculateMetrics = (data: any) => {
  // Average read time calculation
  data.avgReadtime = data.reads > 0 ? roundTo((data.totalReadtime || data.avgReadtime * data.reads * 1000) / 1000 / data.reads, 1) : 0

  // Click out rate calculation  
  data.cotr = data.reads > 0 ? roundTo((data.clickOuts / data.reads) * 100, 2) : 0

  // Cost per acquisition calculation
  data.cpa = data.conversions > 0 ? roundTo(data.totalCost / data.conversions, 2) : 0

  // Click through rate calculation
  data.ctr = data.tdImpressions > 0 ? roundTo((data.tdClicks / data.tdImpressions) * 100, 2) : 0

  // Effective cost per mille calculation
  data.eCpm = data.tdImpressions > 0 ? roundTo(data.publisherRevenue / (data.tdImpressions / 1000), 2) : 0

  // Impressions to reads ratio calculation (per mille)
  data.imps_reads = data.tdImpressions > 0 ? roundTo((data.reads / data.tdImpressions) * 1000, 2) : 0

  // Revenue per acquisition calculation
  data.rpa = data.conversions > 0 ? roundTo(data.publisherRevenue / data.conversions, 2) : 0

  return data
}